import React from 'react';
import { PolicyFromText } from '../../components/ui/PolicyFromText';
import { shippingPolicy } from '../../data/policies/shipping';
export function Shipping() {
  return <PolicyFromText doc={shippingPolicy} data-id="element-1134" data-mp="3cr3k5lntzbkp" />;
}